// The shared-logger registry stays in roo-shared (this is where roo-shared's own tools reach the
// app's logger via getSharedLogger). The RooLogger CLASS now lives in roo-telemetry; we only need
// its type here. The app constructs the logger via createRooLogger and registers it with setSharedLogger.
let logger = null;
export function setSharedLogger(p) {
    if (!logger) {
        logger = p.logger;
    }
}
export function getSharedLogger() {
    if (!logger) {
        throw new Error("Must init logger before calling getLogger zsRxRD5rm0");
    }
    return logger;
}
//# sourceMappingURL=log.service.js.map